
const claimWorkflowMembersBulkUploadColumns = [
  {
    field: "",
    key: "numbering",
    title: "#",
    width: 10,
    align: "center",
    type: "expand",
    renderBodyCell: ({ rowIndex }) => {
      return ++rowIndex;
    },
    
  },
 
  {
    field: "EmployeeNo",
    key: "EmployeeNo",
    title: "Employee No",
    headerAlign: "left",
    align: "left",
 
  },
  {
    field: "WorkflowName",
    key: "WorkflowName",
    title: "Workflow Name",
    headerAlign: "left",
    align: "left",
  
  },
 
];

export default claimWorkflowMembersBulkUploadColumns;
